import { createUser as T, generateUserKey as C, sendPerfMetrics as L, removeMessageFeedback as F, addMessageFeedback as I, getEvent as S, createEvent as K, deleteUser as R, updateUser as w, getUser as _, createFile as q, deleteMessage as N, getMessage as z, updateMessage as A, createMessage as J, listParticipants as j, getParticipant as D, removeParticipant as V, addParticipant as X, listConversationMessages as Y, listConversations as B, deleteConversation as G, getConversation as H, createConversation as O } from "./webchat-client3.js";
import { client as l } from "./webchat-client4.js";
import { EventSource as Q } from "./webchat-client5.js";
import { throwErrorInterceptor as b } from "./webchat-client6.js";
import { createEventEmitter as $ } from "./webchat-client7.js";
const r = (a) => a.data, M = 10, P = 3e3, W = "60000", U = {
  throwOnError: !0
}, ne = async ({
  clientId: a,
  apiUrl: h,
  adminSecret: c,
  customHeaders: o,
  ...d
}) => {
  const t = `${h || l.getConfig().baseUrl}/${a}`;
  l.interceptors.response._fns.length === 0 && l.interceptors.response.use(b);
  const i = {
    ...U,
    baseUrl: t
  }, s = {
    ...c ? { "x-admin-secret": c } : {},
    ...o
  };
  return T({
    ...i,
    headers: Object.keys(s).length > 0 ? s : void 0,
    body: d
  }).then(r);
}, ae = ({
  conversationId: a,
  userToken: h,
  clientId: c,
  apiUrl: o,
  adminSecret: d
}) => {
  let t = 0, i = null;
  const s = $();
  let f = a, e = h;
  const n = () => {
    i && i.close();
    const v = `${`${o || l.getConfig().baseUrl}/${c}`}/initialize${f ? `?conversationId=${f}` : ""}`, m = {
      ...d ? { "x-admin-secret": d } : {},
      ...e ? { "x-user-key": e } : {}
    };
    i = x(v, m), i.addEventListener("open", () => s.emit("open")), i.addEventListener("error", (u) => {
      t < M ? (t++, setTimeout(() => n(), P)) : s.emit("error", u);
    }), i.addEventListener("message", (u) => {
      const g = k(u.data);
      g.type === "init" && (f = g.data.conversation.id ?? f, e = g.data.user.userKey ?? e), s.emit(g.type, g.data);
    });
  };
  return n(), s.on;
}, oe = async ({
  adminSecret: a,
  expiresAt: h,
  userId: c,
  apiUrl: o,
  clientId: d
}) => {
  const t = { "x-admin-secret": a }, i = `${o || l.getConfig().baseUrl}/${d}`, s = {
    ...U,
    baseUrl: i
  };
  return C({ ...s, headers: t, body: { id: c, expiresAt: h } }).then(r);
}, ie = async (a, h, c, o) => {
  const d = `${c || l.getConfig().baseUrl}/${a}`, t = {
    ...U,
    baseUrl: d
  };
  return L({ ...t, body: h, headers: o }).then(r);
}, ce = ({
  userKey: a,
  clientId: h,
  apiUrl: c,
  customHeaders: o,
  advancedOptions: d
}) => {
  const t = {
    "x-user-key": a,
    ...o
  }, i = `${c || l.getConfig().baseUrl}/${h}`, s = {
    ...U,
    baseUrl: i
  };
  return l.interceptors.response._fns.length === 0 && l.interceptors.response.use(b), {
    createConversation: () => O({ ...s, headers: t, body: {} }).then(r),
    getConversation: ({ conversationId: e }) => H({ ...s, headers: t, path: { id: e } }).then(r),
    deleteConversation: ({ conversationId: e }) => G({ ...s, headers: t, path: { id: e } }).then(r),
    listConversations: ({ nextToken: e }) => B({ ...s, headers: t, query: { nextToken: e } }).then(r),
    listConversationMessages: ({ conversationId: e, nextToken: n }) => Y({
      ...s,
      headers: t,
      path: { id: e },
      query: { nextToken: n }
    }).then(r),
    addParticipant: ({ conversationId: e, userId: n }) => X({ ...s, headers: t, path: { id: e }, body: { userId: n } }).then(r),
    removeParticipant: ({ conversationId: e, userId: n }) => V({ ...s, headers: t, path: { id: e, userId: n } }).then(r),
    getParticipant: ({ conversationId: e, userId: n }) => D({ ...s, headers: t, path: { id: e, userId: n } }).then(r),
    listParticipants: ({ conversationId: e, nextToken: n }) => j({ ...s, headers: t, path: { id: e }, query: { nextToken: n } }).then(r),
    createMessage: (e) => J({ ...s, headers: t, body: e }).then(r),
    updateMessage: ({ messageId: e, ...n }) => A({ ...s, headers: t, path: { id: e }, body: n }).then(r),
    getMessage: ({ messageId: e }) => z({ ...s, headers: t, path: { id: e } }).then(r),
    deleteMessage: ({ messageId: e }) => N({ ...s, headers: t, path: { id: e } }).then(r),
    createFile: (e) => q({ ...s, headers: t, body: e }).then(r),
    getUser: () => _({ ...s, headers: t }).then(r),
    updateUser: (e) => w({ ...s, headers: t, body: e }).then(r),
    deleteUser: () => R({ ...s, headers: t }).then(r),
    createEvent: (e) => K({ ...s, headers: t, body: e }).then(r),
    getEvent: ({ eventId: e }) => S({ ...s, headers: t, path: { id: e } }).then(r),
    addMessageFeedback: ({ messageId: e, ...n }) => I({ ...s, headers: t, path: { id: e }, body: n }).then(r),
    removeMessageFeedback: ({ messageId: e }) => F({ ...s, headers: t, path: { id: e } }).then(r),
    generateUserKey: ({ adminSecret: e, ...n }) => C({ ...s, headers: { "x-admin-secret": e }, body: n }).then(r),
    listenConversation: ({ conversationId: e }) => {
      let n = 0, p = null;
      const v = $(), m = () => {
        p && p.close();
        const u = `${i}/conversations/${e}/listen`, g = d == null ? void 0 : d.eventSource;
        p = g ? g({ url: u, headers: t }) : x(u, t), p.addEventListener("open", () => v.emit("open")), p.addEventListener("error", (E) => {
          n < M ? (n++, setTimeout(() => m(), P)) : v.emit("error", E);
        }), p.addEventListener("message", (E) => {
          const y = k(E.data);
          v.emit(y.type, y.data);
        });
      };
      return m(), v.on;
    }
  };
}, k = (a) => {
  try {
    return JSON.parse(a);
  } catch {
    return a;
  }
}, x = (a, h) => new Q(a, {
  fetch: (c, o) => fetch(c, {
    ...o,
    headers: {
      ...o == null ? void 0 : o.headers,
      ...h,
      timeout: W
    }
  })
});
export {
  ce as createClient,
  ne as createUser,
  oe as generateUserKey,
  ae as initialize,
  ie as sendPerfMetrics
};
